import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { TelemetryServices } from 'src/app/core/services/telemetry.service';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  standalone: false,
})
export class ConfirmDialogComponent implements OnInit, OnDestroy {
  title: string;
  message: string;
  data2 = {
    // Required
    type: 'Confirm dialog component', //Required. Impression type (list, detail, view, edit, workflow, search)
    subtype: '', //Optional. Additional subtype. "Paginate", "Scroll"
    pageid: '11', //Required.  Unique page id
    itype: '', // type of interaction - SWIPE, SCRUB (fast forward using page thumbnails) or AUTO
    stageto: '', // game level, stage of page id to which the navigation was done
  };
  isShowComment: boolean = false;
  comment: string = '';

  constructor(
    private _telemetryServices: TelemetryServices,
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogModel,
  ) {
    // Update view with given values
    this.title = data.title;
    this.message = data.message;
    this.isShowComment = data['isShowComment'] || false;
  }

  ngOnInit() {
    // telemtry  API CALL and, send data

    this.data2.subtype = 'Confirm dialog';
    this.data2.itype = 'AUTO';
    this.data2.stageto = 'confirm dialog loading page';
    if (this.data2) {
      // this._telemetryServices.telemetryImpression(this.data2);
    }
  }

  onConfirm(): void {
    // Close the dialog, return true
    this.data2.subtype = 'button clcik';
    this.data2.itype = 'on button click';
    this.data2.stageto = 'confirm the attachment or not';
    if (this.data2) {
      // this._telemetryServices.telemetryInteract(this.data2);
    }
    if (this.isShowComment) {
      this.dialogRef.close({ confirmed: true, comment: this.comment });
    } else {
      this.dialogRef.close(true);
    }
  }

  onDismiss(): void {
    // Close the dialog, return false
    this.data2.subtype = 'button clcik';
    this.data2.itype = 'on button click';
    this.data2.stageto = 'confirm the attachment or not';
    if (this.data2) {
      // this._telemetryServices.telemetryInteract(this.data2);
    }
    this.dialogRef.close(false);
  }
  ngOnDestroy() {
    // telemtry end call

    this.data2.subtype = 'Confirm dialog cleanup stage/end of page';
    this.data2.itype = 'AUTO';
    this.data2.stageto = 'destroy component,initial page';
    if (this.data2) {
      // this._telemetryServices.telemetryEnd(this.data2);
    }
  }
}

/**
 * Class to represent confirm dialog model.
 *
 * It has been kept here to keep it as part of shared component.
 */
export class ConfirmDialogModel {

  constructor(public title: string, public message: string, public isShowComment?: boolean,
    public isHtmlContent?: boolean, public confirmButtonText?: string, public showCancelButton?: boolean) {
  }
}
